import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Title from '../../../components/Title';
import { filterStores } from '../../../store/slices/storesSlice';
import StoreList from '../../../components/StoreList';
import { StoreService } from '../../../types/store';
const BuyLevia = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(filterStores({ services: [StoreService.Levia] }));
        return () => {
            dispatch(filterStores({}));
        };
    }, []);
    return (_jsx("div", { children: _jsx(StoreList, { headerComponent: _jsx(Title, { viewInMap: true, title: t('store_locator.buy-levia.title') }) }) }));
};
export default BuyLevia;
